const TIPOS_METHODS = [
  {
    value: 'GET',
    body: false,
  },
  {
    value: 'POST',
    body: true,
  },
  {
    value: 'PUT',
    body: true,
  },
  {
    value: 'DELETE',
    body: true,
  },
  {
    value: 'HEAD',
    body: false,
  },
  {
    value: 'OPTIONS',
    body: false,
  },
]

export {
  TIPOS_METHODS
}
